import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FilterType from './FilterType'
import { actions } from '../../../store'

const mapStateToProps = state => ({
  filters: state.storage.filters
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addFilesTypeFilter: actions.storage.addFilesTypeFilter,
  removeFilesTypeFilter: actions.storage.removeFilesTypeFilter
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterType)



// WEBPACK FOOTER //
// ./src/components/Parts/FilterType/index.js